import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import InsightsPromo from '../../../../assets/images/upsell-insights.png'

import './InsightsUpsell.scss'

export const InsightsUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={<img src={InsightsPromo} alt='Insights promo' className='zocks-border-0.5 insights-upsell-promo object-fit-contain' />}
      heading={
        <>
          Turn your conversations into your competitive edge with <span className='zocks-text-primary'>Insights</span>
        </>
      }
      description='Know what clients care about, spot opportunities early, and grow your practice — all from one page.'
    />
  )
}

export const InsightsUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Conversation intelligence' description='Automatically surface what clients are discussing, asking, and feeling.' />
      <UpsellFeatureItem title='Opportunity tracking' description='See how held-away assets and referrals move from conversation to action.' />
      <UpsellFeatureItem
        title='Practice highlights'
        description='Get the key takeaways from your meetings in a single scan. No manual analysis needed.'
        className='mb-3'
      />
    </>
  )
}
